import React, {FC, useCallback, useState} from "react";
import {
    IAssessmentTemplateGroup,
    IControlMeasure,
    IControlMeasureAssessment,
    IDocument, IInvestigation,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, TextField,
    Typography
} from "@material-ui/core";


import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";

interface IInvestigationProps {
    investigation: IInvestigation
    updateInvestigation: (investigation: IInvestigation) => void;
    closeDialogCallback: () => void;

}

const AddInvestigationDialog: FC<IInvestigationProps> = ({
                                                              investigation,
                                                               closeDialogCallback,
                                                               updateInvestigation}) => {

    const [newInvestigation, setNewInvestigation]= useState<IInvestigation>(investigation);



    const renderField = <T,>(obj: T, key: keyof T,
                             label: string,
                             type: string,
                             setObj:(obj:T) => void) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }


    const [documentRef, setDocumentRef] = useState<IDocument>( () =>
        {
            if (investigation.document) {
                return investigation.document
            }
            return {}
        }

    );

    const updateDocumentSelection = useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)

    }, [setDocumentRef]);



    const submitControlMeasure = () => {
        let ra = {...newInvestigation}
        if (documentRef?.id) {
            ra["document_id"] = documentRef.uuid;
        }
        updateInvestigation(ra)
        closeDialogCallback()
    }



    return (  <Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Add Investigation</DialogTitle>
            <DialogContent>
                {/* <DialogContentText>
                    Add Investigation
                </DialogContentText> */}

                {renderField<IInvestigation>(newInvestigation,
                    "name",
                    "Investigation",
                    "string", setNewInvestigation)}

                {renderField<IInvestigation>(newInvestigation,
                    "cost",
                    "Cost",
                    "number", setNewInvestigation)}

                {renderField<IInvestigation>(newInvestigation,
                    "timeframe",
                    "Timeframe",
                    "number", setNewInvestigation)}

                <Documents updateDocumentID={updateDocumentSelection}/>

            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialogCallback} color="primary">
                    Cancel
                </Button>
                <Button onClick={submitControlMeasure} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddInvestigationDialog;
